import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import GenericModal from '../../../components/modal/GenericModal';
import { formatFechaHoraLocal } from './utils/convocatoriaRecap';

// ──────────────────────────────────────────────────────────────────────────
// AGA-756: "Apto en espera" en Asignación de Vacante (AsignarVacante.jsx) pide la
// fecha de vigencia de la postulación (obligatoria, no pasada) antes de guardar,
// solo en convocatorias de Traslado. Se guarda en TP_Postulante.FechaVigenciaEspera
// y sale en el correo TR_AV_01 ("vigente hasta el dd/mm/aaaa"), que GDH envía
// después con el ícono de avión. Cancelar cierra sin aplicar Apto en espera.
// Mismo patrón que MotivoNoAptoModal.jsx; DatePicker igual que "Fecha de Traslado".
// ──────────────────────────────────────────────────────────────────────────

const inicioDeHoy = () => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return hoy;
};

const FechaVigenciaEsperaModal = ({ toggleModal, onConfirm }) => {
    const [fechaVigencia, setFechaVigencia] = useState(null);
    const [isSending, setIsSending] = useState(false);

    const handleGuardar = async () => {
        if (!fechaVigencia) {
            toast.error('Indica la fecha de vigencia de la postulación.');
            return;
        }
        if (fechaVigencia < inicioDeHoy()) {
            toast.error('La fecha de vigencia no puede ser anterior a hoy.');
            return;
        }
        setIsSending(true);
        try {
            // "yyyy-MM-dd" con los getters locales (formatFechaHoraLocal), no con
            // toISOString(), que pasa a UTC y puede mover el día.
            await onConfirm(formatFechaHoraLocal(fechaVigencia).slice(0, 10));
        } finally {
            setIsSending(false);
        }
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Apto en espera" width="480px">
            <div className="modal-body">
                <p className="text-muted" style={{ fontSize: 13 }}>
                    Indica hasta qué fecha se mantendrá vigente la postulación del candidato.
                </p>

                <div className="form-group">
                    <label className="modal-label mb-0 required">Fecha de vigencia</label>
                    <DatePicker className="form-control" name="FechaVigencia"
                        selected={fechaVigencia}
                        onChange={(date) => setFechaVigencia(date)}
                        minDate={new Date()}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="dd/mm/aaaa"
                        disabled={isSending} />
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button type="button" className="btn btn-outline-secondary mr-2" disabled={isSending}
                        onClick={toggleModal}>
                        Cancelar
                    </button>
                    <button type="button" className="btn generic-button-buscador"
                        disabled={isSending} onClick={handleGuardar}>
                        Guardar
                    </button>
                </div>
            </div>
        </GenericModal>
    );
};

export default FechaVigenciaEsperaModal;
